import './styles/modal.scss';
import './styles/modal-theme.scss';
import modalModule from './modal';
export default modalModule;
